import styled from 'styled-components';

/* Mixins */
import { InlineFlexCenterChildren } from 'styles/Mixins';

export const Button = styled.div<{ [props: string]: any }>`
  position: relative;
  border-radius: 4px;
  padding: ${({ padding }) => padding || '0 16px'};
  ${({ disabled }) => disabled && 'opacity: 0.6'};
  ${({ bold }) => {
    if (bold !== undefined && bold !== null) {
      return bold
        ? 'font-weight: bold !important'
        : 'font-weight: normal !important';
    }
    return '';
  }};
  ${({ stretch }) => stretch && 'width: 100%'};
  ${InlineFlexCenterChildren};
  flex-shrink: 0;
  transition: background-color 0.2s ease;

  :focus {
    outline: 0;
  }
  :hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;
